import React from 'react';
import styled from 'styled-components';

type Props = {
  style?: React.CSSProperties;
  left?: React.ReactNode;
  right?: React.ReactNode;
  leftStyle?: React.CSSProperties;
  rightStyle?: React.CSSProperties;
};

export const HorizontalContent: React.FC<Props> = props => {
  return (
    <Container style={props.style}>
      {!!props.left && <Left style={props.leftStyle}>{props.left}</Left>}
      {!!props.right && <Right style={props.rightStyle}>{props.right}</Right>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 13px;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 13px;
  }
`;
